import { BRAND_COLORS, GRAY_COLORS } from '@/UIlibrary/globalTheme';
import React from 'react';

type DataObject = Record<string, any>;

export interface FlexibleTableProps {
	data: DataObject | DataObject[];
	flipped?: boolean;
}

const FlexibleTable: React.FC<FlexibleTableProps> = ({ data, flipped = false }) => {
	const dataArray = Array.isArray(data) ? data : [data];

	const allKeys = Array.from(new Set(dataArray.flatMap((obj) => Object.keys(obj))));

	const renderStandardTable = () => (
		<table className={`w-full border-collapse overflow-x-scroll`}>
			<thead>
				<tr style={{ backgroundColor: BRAND_COLORS.brand500, borderRadius: '10px' }}>
					{allKeys.map((key) => (
						<th key={key} className="border border-white px-4 py-2 text-white text-left text-sm">
							{key}
						</th>
					))}
				</tr>
			</thead>
			<tbody>
				{dataArray.map((row, rowIndex) => (
					<tr
						key={rowIndex}
						style={{ backgroundColor: rowIndex % 2 === 0 ? 'white' : BRAND_COLORS.brand50 }}
					>
						{allKeys.map((key) => (
							<td
								key={`${rowIndex}-${key}`}
								style={{ borderColor: GRAY_COLORS.gray300 }}
								className="border px-4 py-2 text-sm"
							>
								{row[key] !== undefined && row[key] !== null ? String(row[key]) : '-'}
							</td>
						))}
					</tr>
				))}
			</tbody>
		</table>
	);

	const renderFlippedTable = () => (
		<table className={`w-full border-collapse overflow-x-scroll`}>
			<tbody>
				{allKeys.map((key, keyIndex) => (
					<tr
						key={key}
						style={{ backgroundColor: keyIndex % 2 === 0 ? 'white' : BRAND_COLORS.brand50 }}
					>
						<th
							style={{ backgroundColor: BRAND_COLORS.brand500, borderColor: 'white' }}
							className="border px-4 py-2 text-white text-left w-1/4 text-sm"
						>
							{key}
						</th>
						{dataArray.map((row, rowIndex) => (
							<td
								key={`${key}-${rowIndex}`}
								style={{ borderColor: GRAY_COLORS.gray300 }}
								className="border px-4 py-2 text-sm"
							>
								{row[key] !== undefined && row[key] !== null ? String(row[key]) : '-'}
							</td>
						))}
					</tr>
				))}
			</tbody>
		</table>
	);

	return flipped ? renderFlippedTable() : renderStandardTable();
};

export default FlexibleTable;
